import React from 'react'
import ReactTooltip from 'react-tooltip'

const TooltipAjuda = (props) => {
  const idAjuda = props.id ? props.id : 'tooltipAjuda'
  if (props.conteudo) {
    return (
      <span className="align-self-center">
        <a data-tip data-for={idAjuda}>
          <i className="material-icons ajuda-icon">&#xe8fd;</i>
        </a>
        <ReactTooltip className='text-left tool-tip-ajuda'
                      id={idAjuda}
                      type='dark'
                      place='right'
                      effect='solid'
                      delayHide={500}
                      delayShow={500}
                      delayUpdate={500}
                      getContent={props.conteudo}/>
      </span>
    )
  }

  return ''
}

export default TooltipAjuda
